import { View } from '@play-co/timestep-core/ui';
import { ProgressBar } from 'src/game/components/shared/ProgressBar';

export default class Match2ProgressBar extends ProgressBar {
  constructor({
    superview,
    width = 380,
    height = 58,
    x,
    y,
    scale = 1,
    canHandleEvents = true,
  }: {
    superview: View;
    width?: number;
    height?: number;
    x?: number;
    y?: number;
    scale?: number;
    canHandleEvents?: boolean;
  }) {
    super({
      superview,
      bgStyle: {
        image: 'assets/ui/match2/common/bar_frame_green.png',
        width,
        height,
        scaleMethod: '9slice',
        sourceSlices: {
          horizontal: { left: 40, right: 40 },
        },
        canHandleEvents,
      },
      fillStyle: {
        image: 'assets/ui/match2/common/bar_fill_green.png',
        width: 0,
        height: height * (46 / 58),
        x: 5,
        y: 1.8,
        paddingRight: 5,
        scaleMethod: '9slice',
        sourceSlices: {
          horizontal: { left: 34, right: 34 },
        },
      },
    });

    this.updateOpts({
      width,
      height,
      x,
      y,
      scale,
    });
  }

  public get fillWidthRatio() {
    const max = (this.style.width ?? 497) - this.paddingRight;
    return this.progressFill.style.width / max;
  }
}
